import React from 'react';
import { Box, Typography, Card, CardContent, List, ListItem, ListItemText } from '@mui/material';

const OficiulCanonic: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Oficiul Canonic
      </Typography>
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Responsabil: Armand Remus
          </Typography>
          <Typography variant="body1">
            Oficiul Canonic se ocupă de aspectele canonice ale bisericii, 
            interpretarea și aplicarea dreptului canonic ortodox.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default OficiulCanonic;
